import { put, call } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    getCareerPathSuccess, getCareerPathFail,
    getAllCareerPathsSuccess, getAllCareerPathsFail,
    getActiveCareerPathsSuccess, getActiveCareerPathsFail,
    createCareerPathSuccess, createCareerPathFail,
    updateCareerPathSuccess, updateCareerPathFail,
    deleteCareerPathSuccess, deleteCareerPathFail,
    setCareerPathLoading, getAllCareerPathsRequest
} from '../actions/careerPathActions';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from '../../../api';

export function* getCareerPathSaga(action) {
    const url = `${API_BASE_URL}/api/career-paths/${action.payload.careerPathId}`;
    yield put(setCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getCareerPathSuccess(resp.data));
    } catch (error) {
        yield put(getCareerPathFail(error.message));
    } finally {
        yield put(setCareerPathLoading(false));
    }
}

export function* getAllCareerPathsSaga() {
    const token = sessionStorage.getItem('token');
    const url   = `${API_BASE_URL}/api/career-paths`;
    yield put(setCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getAllCareerPathsSuccess(resp.data));
    } catch (error) {
        yield put(getAllCareerPathsFail(error.message));
    } finally {
        yield put(setCareerPathLoading(false));
    }
}

export function* getActiveCareerPathsSaga() {
    const token = sessionStorage.getItem('token');
    const url   = `${API_BASE_URL}/api/career-paths/active`;
    yield put(setCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getActiveCareerPathsSuccess(resp.data));
    } catch (error) {
        yield put(getActiveCareerPathsFail(error.message));
    } finally {
        yield put(setCareerPathLoading(false));
    }
}

export function* createCareerPathSaga(action) {
    const url  = `${API_BASE_URL}/api/career-paths`;
    const data = action.payload;
    yield put(setCareerPathLoading(true));
    try {
        const resp = yield call(postRequest, { url, data });
        yield put(createCareerPathSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Parcours créé avec succès',
            timer: 2000, showConfirmButton: false
        });
        yield put(getAllCareerPathsRequest());
    } catch (error) {
        yield put(createCareerPathFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: 'Erreur lors de la création',
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setCareerPathLoading(false));
    }
}

export function* updateCareerPathSaga(action) {
    const url  = `${API_BASE_URL}/api/career-paths/${action.payload.careerPathId}`;
    const data = action.payload.careerPathData;
    yield put(setCareerPathLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateCareerPathSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Parcours mis à jour avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        yield put(updateCareerPathFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: 'Erreur lors de la mise à jour',
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setCareerPathLoading(false));
    }
}

export function* deleteCareerPathSaga(action) {
    const url = `${API_BASE_URL}/api/career-paths/${action.payload.careerPathId}`;
    yield put(setCareerPathLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteCareerPathSuccess(action.payload.careerPathId));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: 'Succès', text: 'Parcours supprimé avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        const errorMessage = error.response?.data?.message
            || error.response?.data?.error
            || error.message
            || 'Erreur lors de la suppression';
        yield put(deleteCareerPathFail(errorMessage));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: 'Erreur de suppression', text: errorMessage,
            confirmButtonText: 'OK', confirmButtonColor: '#d33'
        });
    } finally {
        yield put(setCareerPathLoading(false));
    }
}